<template>
    <div class="site-container">
        <h1>404</h1>
        <p>Page not found</p>
    </div>
</template>
